import React, { useEffect, useState } from "react";
// import InputField from "../../common_component/component/InputField";
import { useNavigate, useSearchParams } from "react-router-dom";
// import {
//   ADD_ICON,
//   COPY_ICON,
//   EDIT_ICON,
//   VIEW_ICON,
// } from "../../cufront-assets/icons/Icons";

import { useItemsFilter } from "../../_helper/actions/app/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { useAtom } from "jotai";
import { clinicAtom } from "../../_helper/constant/constant-atom";
// import CuScreenLoader from "../../common_component/component/CuScreenLoader";
// import FilterComponent from "../components/FilterComponent";
import Table from "../../common_component/component/Table";
import Confirmation from "../../common_component/component/Confirmation";
import CuModal from "../../common_component/component/CuModal";
import { useSecureDeleteItem } from "../../_helper/actions/mutation/items";
import { toast } from "react-toastify";
// import CreateRoles from "../components/CreateRoles";

const Roles = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const groupId = searchParams.get("group_id");
  const optionId = searchParams.get("option_id");
  const mode = searchParams.get("mode");
  const [permissionsData, setPermissionsData] = useState();
  const [filteredData, setFilteredData] = useState([]);
  const [deleteId, setDeleteId] = useState(null);
  // const [selectedFilter, setSelectedFilter] = useState([
  //   { filterBy: "name", filterClause: "is", filterText: "" },
  // ]);
  const [clinic] = useAtom(clinicAtom);
  const [searchInput, setSearchInput] = useState();

  const query = `?action=getRoles&clinic_id=${
    clinic?.id
  }&frontend=True&admin_roles=True${
    searchInput?.length > 0 ? `&name=${searchInput}` : ""
  }`;

  const { data, isLoading } = useItemsFilter(
    ApiEndPoint?.USERS,
    query,
    clinic?.id ? true : false
  );

  useEffect(() => {
    if (data) {
      setPermissionsData(data);
      setFilteredData(data);
    }
  }, [data]);

  const handleEdit = (id) => {
    navigate(
      `/new/setup?group_id=${groupId}&option_id=${optionId}&mode=edit&id=${id}`
    );
  };

  const handleView = (id) => {
    navigate(
      `/new/setup?group_id=${groupId}&option_id=${optionId}&mode=view&id=${id}`
    );
  };

  const handleCopyClick = (id) => {};

  const handleCreateRoles = () => {
    navigate(
      `/new/setup?group_id=${groupId}&option_id=${optionId}&mode=create`
    );
  };

  const handleSearch = (e) => {
    setSearchInput(e.target?.value);
  };

  const onDelete = (id) => {
    setDeleteId(id);
  };

  const deleteMutation = useSecureDeleteItem(ApiEndPoint?.USERS);

  const handleDeleteData = (delId) => {
    const payload = {
      action: "delRoles",
      clinic_id: clinic?.id,
      backend: "True",
      id: Number(delId),
    };

    deleteMutation.mutate(payload, {
      onSuccess: () => {
        toast.success("Deleted Successfully");
        setDeleteId(null);
      },
      onError: (err) => toast.error(err.response.data.message),
    });
  };

  const columns = [
    { header: "Name", accessor: "name" },
    { header: "Description", accessor: "description" },
    { header: "Action", accessor: "action" },
  ];

  return (
    <>
      {!mode && (
        <Table
          columns={columns}
          // filters={selectedFilter}
          // onFilterChange={handleFilterChange}
          // onAddFilter={handleAddFilter}
          // onRemoveFilter={handleRemoveFilter}
          data={filteredData}
          onViewClick={handleView}
          onEditClick={handleEdit}
          onDeleteClick={onDelete}
          // onCopyClick={handleCopyClick}
          onSearchChange={handleSearch}
          navigation={true}
          onAddClick={handleCreateRoles}
        />
      )}
      {/* {mode && <CreateRoles mode={mode} />}
      {isLoading && <CuScreenLoader />} */}
      {deleteId && (
        <CuModal closeModal={() => setDeleteId(null)}>
          <Confirmation
            heading={`Delete`}
            onCancel={() => setDeleteId(null)}
            onClick={() => handleDeleteData(deleteId)}
            loading={deleteMutation.isLoading}
          />
        </CuModal>
      )}
    </>
  );
};

export default Roles;
